<template>
   <div class="user_view__alerts">
        <alert-item 
        v-for="(alert, i) in data"
        :alert="alert" 
        :key="i" 
        class="user_view__alerts__item">
        
        </alert-item>
    </div>
</template>
<script>
import AlertItem from './AlertItem'
export default {
  props:{
       data: Array,
       loading: {
           type: Boolean,
           default: true
        },
       error: Boolean,
       color:{
           type: String,
           default: 'yellow'
       }
   },
   components:{
       'alert-item': AlertItem
   }
}
</script>


// WEBPACK FOOTER //
// src/components/shared/AlertsList.vue